import React, { useEffect, useState } from "react";
import "./scrollup.css";
import Icon from "../ui/Icon";

const THRESHOLD = 720;

const ScrollUp = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > THRESHOLD);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <a href="#top" className="scrollup" data-visible={visible} aria-label="Back to top" tabIndex={visible ? 0 : -1}>
      <Icon name="up" />
    </a>
  );
};

export default ScrollUp;
